import { bytesToHex } from "@sundae/cardano-utils";
import { useI18N } from "@sundae/react-hooks";
import { useWalletObserver } from "@sundaeswap/wallet-lite";
import { useMutation } from "@tanstack/react-query";
import { getProposalsSdk } from "../graphql/client/proposals";
import { useGetChosenUtxos } from "./useGetChosenUtxos";
export const NOT_ENOUGH_ADA_ERROR = /not enough ada \((\d+)\) for riders and fees/;
export const useVoteActions = () => {
    const { t } = useI18N("error");
    const { mainAddress, observer, utxos } = useWalletObserver();
    const { mutateAsync } = useGetChosenUtxos();
    const checkVotesMutation = useMutation(async ({ proof, input }) => {
        const { checkVotes } = await getProposalsSdk();
        return checkVotes({
            proof,
            input,
        });
    }, {
        cacheTime: 0,
    });
    const castVotesMutation = useMutation(async ({ proof, vote }) => {
        const { castVote } = await getProposalsSdk();
        return castVote({
            proof,
            vote,
        });
    }, {
        cacheTime: 0,
    });
    const castVotesOnchainMutation = useMutation([utxos], async ({ payload }) => {
        const { data, notEnoughAda } = await mutateAsync(utxos);
        if (notEnoughAda) {
            throw new Error(t("notEnoughAda"));
        }
        const { onchainVote } = await getProposalsSdk();
        const { onchainVote: { cborHex }, } = await onchainVote({
            inputs: data.map((utxo) => ({
                index: Number(utxo.input().index()),
                txHash: utxo.input().transactionId(),
            })),
            returnAddress: mainAddress,
            vote: JSON.parse(payload),
        });
        const { decode, encode } = await import("cbor-web");
        const serverTx = decode(cborHex);
        const clientHexWitnessSet = await observer.api.signTx(cborHex, true);
        const clientWitnesses = decode(clientHexWitnessSet);
        // If the server returned no witnesses, just use the ones provided from the wallet
        if ("undefined" === typeof serverTx[1] || !(serverTx[1] instanceof Map)) {
            serverTx[1] = clientWitnesses;
            // Merge the two witness sets together.
        }
        else {
            for (const witness of clientWitnesses.get(0)) {
                serverTx[1].get(0).push(witness);
            }
        }
        const signedTxCbor = bytesToHex(encode(serverTx));
        const hash = await observer.api.submitTx(signedTxCbor);
        return hash;
    }, {
        cacheTime: 0,
    });
    return {
        checkVotesMutation,
        castVotesMutation,
        castVotesOnchainMutation,
    };
};
//# sourceMappingURL=useVoteActions.js.map